import { axiosBase } from '../_helpers'

export default { getRequest, postRequest }

function getRequest (url) {
  return axiosBase.get(url)
    .catch(function (error) {
      throw error
    })
    .then(function (response) {
      return response
    })
}

function postRequest (url, data) {
  return axiosBase.post(url, data)
    .catch(function (error) {
      throw error
    })
    .then(function (response) {
      return response
    })
}
